export const isEventEnter = <T extends HTMLElement>(e: React.KeyboardEvent<T>) => {
    return e.key === 'Enter' || e.keyCode === 13 || e.code === 'Enter';
};
export const isEventSpace = <T extends HTMLElement>(e: React.KeyboardEvent<T>) => {
    return e.key === 'Space' || e.keyCode === 32 || e.code === 'Space';
};
export const isEventEscape = <T extends HTMLElement>(e: React.KeyboardEvent<T>) => {
    return e.key === 'Escape' || e.keyCode === 27 || e.code === 'Escape';
};